import { gql } from '@apollo/client';

export const SAVE_AUTOMATIC_USER_ALLOCATIONS = gql`
  mutation saveAutomaticUserAllocations($allocationsToSave: [AutomaticUserAllocationInput], $allocationIdsToDelete: [Int]) {
    saveAutomaticUserAllocations(allocationsToSave: $allocationsToSave, allocationIdsToDelete: $allocationIdsToDelete) {
      commandId
    }
  }
`;
